import React, { Children, useState } from 'react';
import styled from 'styled-components';
import alram_on from '../../../src/images/common/i_alram_on.svg';
import alram_off from '../../../src/images/common/i_alram_off.svg';
import i_pill from '../../../src/images/common/i_pill.svg';
import check_mark_on from '../../../src/images/common/i_check_mark_on.svg';
import check_mark_off from '../../../src/images/common/i_check_mark_off.svg';
import day_morning from '../../../src/images/common/i_day_morning_02.svg';
import day_lunch from '../../../src/images/common/i_day_lunch_02.svg';
import day_night from '../../../src/images/common/i_day_night_02.svg';

import AlertBox from '../../components/box/AlertBox';

import URL from '../../constants/url';

import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';


// 홈케어 > 복약기록 

const RecordContent = styled.div`
    display: block;
    position: relative;
    margin-top: var(--sp-12);
`;

const InnerBox = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    position: relative;
    z-index: 1;
    padding: var(--sp-16);
    border-radius: var(--radius-16);
    background-color: var(--color-white);
`;

const InfomBox = styled.div`
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    gap: var(--sp-04);
    width: 100%; 
`;

const TopBox = styled.ul`
    display: flex;
    align-items: center;
    gap: var(--sp-06);
`;

const DayChip = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--sp-02);
    height: var(--sp-20);
    padding: 0 var(--sp-10) 0 var(--sp-06);
    border-radius: var(--radius-100);
    background-color: var(--color-main-25);
    & > i {
        display: block;
        width: var(--sp-14);
        height: var(--sp-14);
    }
    & > span {
        font-size: var(--mo-fz-sm);
        color: var(--color-main-5);
        font-weight: var(--fz-weight-700);
    }
`;

const MealChip = styled.li`
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--sp-20);
    padding: 0 var(--sp-10);
    border-radius: var(--radius-100);
    background-color: var(--color-main-25);
    font-size: var(--mo-fz-sm);
    color: var(--color-main-5);
    font-weight: var(--fz-weight-700);
`;

const EtcChip = styled.li`
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--sp-20);
    padding: 0 var(--sp-10);
    border-radius: var(--radius-100);
    /* 주황빛 배경색과 글자색 설정 */
    background-color: #ffe0b2; /* 연한 주황빛 배경 (예시) */
    font-size: var(--mo-fz-sm);
    color: #e65100; /* 진한 주황색 글자 (예시) */
    font-weight: var(--fz-weight-700);
`;

const MidBox = styled.div`
    padding-top: var(--sp-04);
`;

const MiddBox = styled.div`
    padding-top: 0;
`;

const TypoSub = styled.div`
    & p {
        font-size: var(--mo-fz-smd);
        color: var(--color-main-gray);
        font-weight: var(--fz-weight-700);
    }
    & p.complete {
        color: var(--color-main-5);
    }
`;

const TypoDetail = styled.p`
    font-size: var(--mo-fz-sm);
    color: var(--color-main-gray-5);
    word-break: break-all;
`;


const ControlBox = styled.div`
    display: flex;
    align-items: center;
    gap: var(--sp-20);
    top: var(--sp-12);
    right: var(--sp-16);
    & .alarm-status-box {
        margin-right: 4rem;
        & span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: var(--sp-20);
            height: var(--sp-20);
            background-image: url(${alram_off});
        }& span[data-alarm="on"] {
            background-image: url(${alram_on});
        }   
    }
    }
`;

const CtrolAlarm = styled.img`
    width: var(--sp-24);
    height: var(--sp-24);
`;

const CheckBox = styled.div`
    position: absolute;
    top: var(--sp-16);
    right: var(--sp-16);
    z-index: 2;
`;



const MedicRecordBox = ({ item, index, chkDay, pillType, checked, onCheckChange }) => {

    const navigate = useNavigate();

    const [localAlarmActive, setLocalAlarmActive] = useState(item?.active);

    // 팝업
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState("");

    const handleOnAlertClose = () => {
        setIsAlertOpen(false);
    };

    // YYYY-MM-DD 형식의 오늘 날짜를 가져오는 함수
    const getTodayDate = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleCheckChange = (e) => {
        const today = dayjs().format('YYYYMMDD'); 
        
        const itemDateString = item.tkmdcnDe;

        if (itemDateString > today) {
            setAlertText('미래 날짜는 완료 처리가 불가합니다.');
            setIsAlertOpen(true);
            return;
        }

        onCheckChange(item.usrTkmedicnInfoId, e.target.checked);
    };

    return (
        <RecordContent>

            <InnerBox onClick={() => {
                pillType ?
                    navigate(URL.PILL_DETAIL_USER, {
                        state: item
                    })
                    : navigate(URL.PILL_DETAIL, {
                        state: item
                    })
                // console.log(JSON.stringify(item, null, 2));
            }}>

                {checked ? (
                    <InfomBox>
                        <MiddBox>
                            {/* <div>{JSON.stringify(item)}</div> */}
                            <TypoSub>
                                {(() => {
                                    const pillListLength = item?.data?.data?.pillList?.length || 0;
                                    const countText = pillListLength > 0 ? pillListLength : '';

                                    let message;
                                    if (pillListLength === 1) {
                                        const pillName = item.data.data.pillList[0] || '약';
                                        message = `${pillName} 약 복용 완료!`;
                                    } else if (pillListLength > 1) {
                                        const firstPillName = item.data.data.pillList[0] || '첫 번째 약';
                                        message = `${firstPillName} 외 ${pillListLength - 1}개 약 복용 완료!`;
                                    } else {
                                        message = '복용 내역 없음';
                                    }

                                    return <p className="complete">{message}</p>;
                                })()}
                            </TypoSub>
                        </MiddBox>
                    </InfomBox>
                ) : (
                    <>
                        <InfomBox>
                            <TopBox>
                                <DayChip>
                                    <img src={
                                        chkDay === "1" ? `${day_morning}` :
                                            chkDay === "2" ? `${day_lunch}` :
                                                chkDay === "3" ? `${day_night}` :
                                                    null
                                    } />
                                    {
                                        <span>{item?.data?.data?.selectedTime}</span>
                                    }

                                </DayChip>
                                {/* <MealChip>식후 30분</MealChip> */}
                                {item?.data?.data?.timing && <MealChip>{item?.data?.data?.timing}</MealChip>}

                                {item?.tkmdcnGrpCd === 'ETC' &&
                                    <EtcChip>처방 외</EtcChip>
                                }
                            </TopBox>
                            <MidBox>
                                <TypoSub>
                                    <p>{item?.cnncDeptNm} {item?.tkmdcnEraNm}약 잘 드셨나요?</p>
                                </TypoSub>
                                <TypoDetail>
                                    {/* <span>우루사정 200mg 외 4개 약</span> */}
                                    {item?.data?.data?.pillList?.length > 0 &&
                                        <span>
                                            {item.data.data.pillList.length === 1
                                                ? `${item.data.data.pillList[0]}`
                                                : `${item.data.data.pillList[0]} 외 ${item.data.data.pillList.length - 1}개 약`
                                            }
                                        </span>
                                    }
                                </TypoDetail>
                            </MidBox>
                        </InfomBox>

                        {(item?.tkmdcnGrpCd != 'G20') &&
                            <ControlBox>
                                <div className="alarm-status-box" onClick={(e) => {
                                    // e.stopPropagation();
                                    // toggleNotification(item?.id);
                                }}>
                                    <span data-alarm={localAlarmActive == 'Y' ? 'on' : null}></span>
                                </div>
                            </ControlBox>
                        }
                    </>
                )}
            </InnerBox>
            <CheckBox>
                <div className="chkbox-custom" data-chkbox="all-btn">
                    <input
                        type="checkbox"
                        id={`pill-${item.usrTkmedicnInfoId}`}
                        checked={checked}
                        onChange={handleCheckChange}
                    />
                    <label htmlFor={`pill-${item.usrTkmedicnInfoId}`}></label>
                </div>
            </CheckBox>

            <AlertBox
                isOpen={isAlertOpen}
                onClose={handleOnAlertClose}
                message={alertText}
                btnTxt='확인'
            />


        </RecordContent>



    );
};

export default MedicRecordBox;
